const CardError = () => {
  return (
    <div className="container-big container-column">
      <h2 className="error-heading">Fehler beim Laden des Portals.</h2>
      <div className="container-error-message">
        <p>
          Die Daten können nicht geladen werden, dies kann folgende Gründe
          haben:
        </p>
        <ul>
          <li>Die Verbindung zum Server konnte nicht hergestellt werden</li>
          <li>Der Server wird aktuell gewartet</li>
          <li>Es trat ein Problem mit der Microsoft Authentifizierung auf</li>
        </ul>
      </div>
    </div>
  );
};

export default CardError;
